import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

interface ValidFormStoreState {
  isValid: boolean;
  registeredForms: { cartItemId: string; isValid: boolean }[];
  setIsValid: (cartItemId: string, isValid: boolean) => void;
  registerForm: (cartItemId: string) => void;
  unregisterForm: (cartItemId: string) => void;
}

export const useValidFormStore = create<ValidFormStoreState>()(
  devtools(
    persist(
      (set, get) => ({
        isValid: true,
        registeredForms: [],
        setIsValid: (cartItemId, isValid) => {
          set((state) => ({
            ...state,
            registeredForms: state.registeredForms?.map((form) =>
              form.cartItemId === cartItemId ? { ...form, isValid } : form,
            ),
          }));

          const allFormsValid = get().registeredForms.every((form) => form.isValid);
          set({ isValid: allFormsValid });
        },
        registerForm: (cartItemId) =>
          set((state) => ({
            ...state,
            registeredForms: [...state.registeredForms, { cartItemId, isValid: false }],
          })),
        unregisterForm: (cartItemId) => {
          set((state) => ({
            ...state,
            registeredForms: state.registeredForms.filter((form) => form.cartItemId !== cartItemId),
          }));

          const isEmpty = get().registeredForms.length === 0;
          set({ isValid: isEmpty });
        },
      }),
      {
        name: "valid-form-storage",
      },
    ),
  ),
);
